import { confirm, DialogResponse } from 'owa-confirm-dialog';
import { lazyCloseCompose, isViewStateDirty } from 'owa-mail-compose-store';
import strings from 'owa-strings/owa-mail-strings';
export var closeItem = function (viewState) { return function () {
    confirm(strings.closeMessage, strings.addinCloseCompose, !isViewStateDirty(viewState) /* Resolve Immediately */, {
        okText: strings.closeButton,
        hideCancelButton: false,
    }).then(function (result) {
        if (result == DialogResponse.ok) {
            lazyCloseCompose.importAndExecute(viewState);
        }
    });
}; };
//# sourceMappingURL=CloseAdapter.js.map